// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import './assets/css/root.css'
import './assets/css/mycss.css'
// import './assets/css/font.css'
import './assets/js/jquery-3.3.1.js'
import './assets/js/bootstrap.js'
import './assets/iconfont/iconfont.css'
import commonJS from './assets/js/common.js'
import api from './assets/js/api.js'
import axios from './axios/axios-init'
import App from './App'
import router from './router'
import i18n   from './assets/js/i18n'
// Vue.use(VueAxios)


Vue.config.productionTip = false
Vue.prototype.api = api
Vue.prototype.commonJS = commonJS
Vue.prototype.axios = axios.axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js